export default __webpack_public_path__ + "static/media/ayudaa.6ce81e7e.png";